
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <city-edit *ngSwitchCase="true"></city-edit>
            <city-details *ngSwitchCase="false"></city-details>
        </div>
    </ng-template>  
</main-form-modal>